<template>
  <v-dialog class="my-custom-dialog" v-model="dialog" persistent max-width="500px">
    <v-card class="mx-auto" max-width="500px" height="100%">
      <div class="d-flex flex-row-reverse">
        <i
          @click="close()"
          class="ki ki-close icon-xs text-muted btn btn-xs btn-icon btn-light btn-hover-primary"
        ></i>
      </div>
      <div class="offcanvas-header d-flex align-items-center">
        <h3 class="m-0 pb-10 dialog-title">
          {{ editMode ? $t("common.edit") : $t("common.add") }} {{ $t("menu.coins") }}
        </h3>
      </div>

      <v-form ref="form" lazy-validation @submit.prevent="save()">
        <v-text-field
          v-model="innerForm.name"
          :label="$t('commonTable.name') + ' *'"
          :rules="rules.required"
        ></v-text-field>

        <v-text-field
          v-model.number="innerForm.rate"
          :label="'Rate' + ' *'"
          :rules="rules.required"
          type="number"
          step="0.01"
        ></v-text-field>

        <v-text-field
          v-model.number="innerForm.giftAmount"
          :label="'Gift Amount' + ' *'"
          :rules="rules.required"
          type="number"
          step="0.01"
        ></v-text-field>

        <div class="d-flex">
          <v-text-field
            v-model.number="innerForm.bulkSize"
            :label="'Bulk Size' + ' *'"
            :rules="rules.required"
            type="number"
            class="mr-2"
          ></v-text-field>

          <v-text-field
            v-model.number="innerForm.bulkPrice"
            :label="'Bulk Price' + ' *'"
            :rules="rules.required"
            type="number"
            step="0.01"
            class="ml-2"
          ></v-text-field>
        </div>

        <div class="d-flex">
          <v-text-field
            v-model.number="innerForm.cashbackAmount"
            :label="'Cashback Amount' + ' *'"
            :rules="rules.required"
            type="number"
            step="0.01"
            class="mr-2"
          ></v-text-field>

          <v-select
            v-model="innerForm.cashbackType"
            :items="cashbackTypes"
            :label="'Cashback Type' + ' *'"
            :rules="rules.required"
            class="ml-2"
          ></v-select>
        </div>

        <div class="pt-4 d-flex justify-content-between align-center">
          <p class="nc-title mb-0">Discounts</p>
          <v-btn small color="primary" @click="addDiscount" v-if="innerForm.discounts.length === 0">
            <v-icon small left>mdi-plus</v-icon>
            {{ $t("common.add") }}
          </v-btn>
        </div>

        <div
          v-for="(discount, index) in innerForm.discounts"
          :key="index"
          class="discount-row d-flex align-center mt-3"
        >
          <v-text-field
            v-model.number="discount.minPrice"
            :label="'Min Price' + ' *'"
            :rules="rules.required"
            type="number"
            step="0.01"
            class="mr-2"
          ></v-text-field>

          <v-text-field
            v-model.number="discount.discount"
            :label="'Discount' + ' *'"
            :rules="rules.required"
            type="number"
            step="0.01"
            class="ml-2"
          ></v-text-field>

          <v-btn
            icon
            small
            class="ml-2"
            @click="removeDiscount(index)"
            v-if="innerForm.discounts.length > 1"
          >
            <v-icon small>mdi-delete</v-icon>
          </v-btn>
        </div>

        <div class="d-flex justify-center mt-3" v-if="innerForm.discounts.length > 0">
          <v-btn small color="primary" @click="addDiscount">
            <v-icon small left>mdi-plus</v-icon>
            {{ $t("common.add") }}
          </v-btn>
        </div>

        <div class="d-flex btn-gap justify-content-end mt-5">
          <v-btn @click="close()" class="ml-4">
            {{ $t("common.cancel") }}
          </v-btn>
          <v-btn color="primary" class="ml-4" type="submit" :disabled="isSaving">
            {{ $t("common.save") }}
          </v-btn>
        </div>
      </v-form>
    </v-card>
  </v-dialog>
</template>

<script>
import { VALIDATORS } from "@/common/validators";
import CoinsApiService from "@/core/services/api.service.coins";

export default {
  name: "coin-dialog",
  props: {
    form: {}
  },
  data() {
    return {
      dialog: false,
      editMode: false,
      isSaving: false,
      coinId: null,
      defaultForm: {
        name: "test",
        rate: 0.1,
        giftAmount: 1.0,
        bulkSize: 1,
        bulkPrice: 0.1,
        cashbackAmount: 1.0,
        cashbackType: "Percentage",
        discounts: [
          {
            minPrice: 0.0,
            discount: 0.0
          }
        ]
      },
      innerForm: {
        name: "test",
        rate: 0.1,
        giftAmount: 1.0,
        bulkSize: 1,
        bulkPrice: 0.1,
        cashbackAmount: 1.0,
        cashbackType: "Percentage",
        discounts: [
          {
            minPrice: 10.0,
            discount: 10.0
          }
        ]
      },
      cashbackTypes: ["Percentage", "FixedAmount"],
      rules: {
        required: VALIDATORS.required
      }
    };
  },
  methods: {
    open(coin = null) {
      this.dialog = true;
      this.editMode = !!coin;

      if (coin) {
        this.coinId = coin.id;
        this.innerForm = JSON.parse(JSON.stringify(coin));
      } else {
        this.coinId = null;
        this.innerForm = JSON.parse(JSON.stringify(this.defaultForm));
      }
    },
    close() {
      this.dialog = false;
    },
    toggle() {
      this.dialog = !this.dialog;
    },
    addDiscount() {
      this.innerForm.discounts.push({
        minPrice: 0.0,
        discount: 0.0
      });
    },
    removeDiscount(index) {
      this.innerForm.discounts.splice(index, 1);
    },
    async save() {
      if (!this.$refs.form.validate()) {
        return;
      }

      this.isSaving = true;

      try {
        let response;
        if (this.editMode) {
          response = await CoinsApiService.updateCoin({
            ...this.innerForm,
            id: this.coinId
          });
        } else {
          response = await CoinsApiService.createCoin(this.innerForm);
        }

        this.close();
        this.$emit("save", {
          formData: this.innerForm,
          response
        });

        // Show success toast
        this.$bvToast.toast(this.$i18n.t("common.savedSuccessfully"), {
          title: this.$i18n.t("menu.coins"),
          solid: true,
          variant: "success",
          autoHideDelay: 1000
        });
      } catch (error) {
        console.error("Error saving coin:", error);
      } finally {
        this.isSaving = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.my-custom-dialog {
  align-self: flex-end;
  height: 100% !important;
  margin: 0 !important;
}

.v-data-table.v-data-table.v-data-table >>> td {
  font-size: 16px;
}
.v-dialog > .v-card {
  padding: 16px;
  display: flex;
  flex-direction: column;
}

::v-deep .v-form .theme--light.v-input input {
  color: #1976d2;
  padding-left: 5px;
}

::v-deep .custom-text .v-text-field {
  padding-top: 0;
}
::v-deep .my-custom-dialog .v-dialog:not(.v-dialog--fullscreen) {
  max-height: 100%;
}

.custom-text {
  color: #333;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0.14px;
}

.dialog-title {
  color: #000;
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  letter-spacing: 0.24px;
}

.nc-title {
  color: #4d4d4d;
  font-size: 20px;
  font-weight: 600;
}
.gap {
  gap: 29px;
  .v-text-field .v-label {
    overflow: visible;
    text-overflow: initial;
  }
}

.exchange-conditions {
  white-space: nowrap;

  span {
    display: inline-block;
  }

  .input-container {
    display: inline-block; /* Keeps input inline */
    .input-num {
      width: 100px;
    }
  }

  .custom-text {
    white-space: normal;
  }
}
</style>
